/* eslint-disable import/prefer-default-export */

/*
 * Converts an enum to an array of values
 */
export const enumToArray = <T>(enumType: T): Array<T[keyof T]> => {
  const enumKeys = Object.keys(enumType as unknown as object).filter((key) => typeof enumType[key as keyof T] === "string");
  return enumKeys.map((key) => enumType[key as keyof T]);
};
